export class WorkItemTypes {
  static readonly CHAT: string = 'CHAT';
  static readonly CHAT_PIN_INVITE: string = 'CHAT_PIN_INVITE';
  static readonly EMAIL: string = 'EMAIL';
  static readonly COMPOSE_EMAIL: string = 'COMPOSE_EMAIL';
  static readonly SMS: string = 'SMS';
  static readonly LENS: string = 'LENS';
  static readonly FACEBOOK: string = 'FACEBOOK';
  static readonly ASYNC_MESSAGE: string = 'ASYNC_MESSAGE';
  static readonly DISCUSSION: string = 'DISCUSSION';
  static readonly OMNI: string = 'OMNI';
  static readonly GENESYS_CHAT = 'GENESYS_CHAT';
  static readonly GENESYS_EMAIL = 'GENESYS_EMAIL';
}

export enum WorkItemTypeValue {
  EMAIL = 4,
  CHAT = 5,
  CHAT_PIN_INVITE = 6,
  SMS = 73,
  LENS = 100,
  FACEBOOK = 101,
  ASYNC_MESSAGE = 106
}

export class WorkItemAvailabilityType {
  static readonly CHAT: string = 'chat';
  static readonly EMAIL: string = 'email';
  static readonly SMS: string = 'sms';
  static readonly FACEBOOK: string = 'facebook';
  static readonly ASYNC_MESSAGE: string = 'asyncMessage';
}
